import { ListAlt } from '@mui/icons-material';

import { DialogButton } from 'components';
import { LogsDialog } from 'components/Dialogs';
import strings from 'constants/index';

type LogButtonProps = {
  entityName: string;
  logsUrl: string;
  additionalSpecialProperties?: string[];
  entityNameMappings?: Record<string, string>;
};

export const LogButton = (props: LogButtonProps) => (
  <DialogButton
    data-testid="logs"
    startIcon={<ListAlt />}
    label={strings.logs}
    dialog={LogsDialog}
    dialogProps={props}
  />
);
